import script from "./QuestionGenPersistentTaskPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionGenPersistentTaskPanel.vue?vue&type=script&setup=true&lang=js"

import "./QuestionGenPersistentTaskPanel.vue?vue&type=style&index=0&id=56cab5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56cab5ec"]])

export default __exports__